import React from 'react'

export default function DigitalSATTestBreakdown(props){
    const currTest = props.test
    if (currTest === '' || currTest === null) return <></>

    const copy = currTest.RW_breakdown.split("-")
    const textcopy = currTest.text_type_breakdown.split("-")
    const englishBreakdown = []
    englishBreakdown.push("Humanities,"+textcopy[0])
    englishBreakdown.push("Social Science,"+textcopy[1])
    englishBreakdown.push("Science,"+textcopy[2])
    englishBreakdown.push("Literature,"+textcopy[3])
    englishBreakdown.push("Poetry,"+textcopy[4])
    englishBreakdown.push("Total,"+textcopy[6])
    const englishCategories = []
    englishCategories.push("Vocab (Fill In),"+copy[0])
    englishCategories.push("Vocab (Context),"+copy[1])
    englishCategories.push("Main Idea,"+copy[2])
    englishCategories.push("Reasoning,"+copy[3])
    englishCategories.push("Objective,"+copy[4])
    englishCategories.push("Data,"+copy[5])
    englishCategories.push("Segment,"+copy[6])
    englishCategories.push("Summary,"+copy[7])
    englishCategories.push("In-Text,"+copy[8])
    englishCategories.push("Format,"+copy[9])
    englishCategories.push("Evidence,"+copy[10])
    englishCategories.push("Comparative Texts,"+copy[11])
    englishCategories.push("Grammar (Transition),"+copy[12])
    englishCategories.push("Grammar (Punctuation),"+copy[13])
    englishCategories.push("Grammar (General),"+copy[14])
    englishCategories.push("Total,"+copy[15])
    const mathCopy = currTest.math_breakdown.split("-")
    const mathBreakdown = []
    mathBreakdown.push("Algebra,"+mathCopy[0])
    mathBreakdown.push("Geometry,"+mathCopy[1])
    mathBreakdown.push("Modeling,"+mathCopy[2])
    mathBreakdown.push("Advanced Topics,"+mathCopy[3])
    mathBreakdown.push("Statistics,"+mathCopy[4])
    mathBreakdown.push("Data,"+mathCopy[5])
    mathBreakdown.push("Total,"+mathCopy[6])
    const typeColors = ['lightgreen','mistyrose','lightblue','gold','orange','lightgray']
    const catColors = ['orange','gold','lightgreen','lightblue','salmon','mistyrose','plum','burlywood','orange','gold','lightgreen','lightblue','salmon','mistyrose','plum','burlywood','lightgray']
    const mathColors = ['salmon','burlywood','orange','gold','lightblue','lightgreen','lightgray']

    return(
        <>
            <div className="scroll-container">
                <div className="rowtable">
                    <div className="question-type-container">
                        <h3>Reading/Writing Categories:</h3>
                        <table className="question-type-table">
                            <tbody>
                                <tr style={{textAlign: 'center'}}>
                                    <td> </td>
                                    <td style={{fontWeight: 'bold'}}>Easy&nbsp;</td>
                                    <td style={{fontWeight: 'bold'}}>Medium&nbsp;</td>
                                    <td style={{fontWeight: 'bold'}}>Hard&nbsp;</td>
                                    <td style={{fontWeight: 'bold'}}>Total&nbsp;</td>
                                </tr>
                                {englishCategories.map((cat,i)=>{
                                    return (
                                        <tr style={{backgroundColor: catColors[i]}}>
                                            {cat.split(",").map((element,j)=>{
                                                return <td>{element}</td>
                                            })}
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                    </div>
                    <div className="question-type-container">
                        <h3>Reading/Writing Text Types:</h3>
                        <table className="question-type-table">
                            <tbody>
                                <tr style={{textAlign: 'center'}}>
                                    <td> </td>
                                    <td style={{fontWeight: 'bold'}}>Easy&nbsp;</td>
                                    <td style={{fontWeight: 'bold'}}>Medium&nbsp;</td>
                                    <td style={{fontWeight: 'bold'}}>Hard&nbsp;</td>
                                    <td style={{fontWeight: 'bold'}}>Total&nbsp;</td>
                                </tr>
                                {englishBreakdown.map((cat,i)=>{
                                    return (
                                        <tr style={{backgroundColor: typeColors[i]}}>
                                            {cat.split(",").map((element,j)=>{
                                                return <td>{element}</td>
                                            })}
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="question-type-container">
                    <h3>Math Question Types:</h3>
                    <table className="question-type-table">
                        <tbody>
                            <tr style={{textAlign: 'center'}}>
                                <td> </td>
                                <td style={{fontWeight: 'bold'}}>Easy&nbsp;</td>
                                <td style={{fontWeight: 'bold'}}>Medium&nbsp;</td>
                                <td style={{fontWeight: 'bold'}}>Hard&nbsp;</td>
                                <td style={{fontWeight: 'bold'}}>Total&nbsp;</td>
                            </tr>
                            {mathBreakdown.map((type,i)=>{
                                return (
                                    <tr style={{backgroundColor: mathColors[i]}}>
                                        {type.split(",").map((element,j)=>{
                                            return <td>{element}</td>
                                        })}
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    )
}